/** Toolbar ile grid arasındaki boşluğu azaltmak ve gridle hizalı yapmak için DataGrid sx */
export const REQUEST_LIST_GRID_COMPACT_SX = {
  "& .MuiDataGrid-toolbarContainer": {
    paddingTop: "4px !important",
    paddingBottom: "4px !important",
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
    minHeight: 36,
  },
};
